module.exports = __webpack_public_path__ + "static/media/builder_hello_world.112ac8bd.gif";